import { components } from '@reactour/tour'
import close_img from '../../../assets/images/close_white.svg'

export const TourNavigation = ({ setCurrentStep, steps, currentStep, setIsOpen, disableAll }) => {
  return (
    <div className='d-flex justify-content-between align-items-center'>
      <div style={{ display: 'flex', justifyContent: 'center', marginTop: '10px', alignItems: "center" }}>
        {console.log(currentStep, steps) }
        {Array.from({ length: steps.length }).map((_, index) => (
          <div
            key={index}
            style={{
              width: currentStep === index ? 7 : 5,
              height: currentStep === index ? 7 : 5,
              borderRadius: '50%',
              opacity: currentStep === index ? '1' : '0.6',
              backgroundColor: currentStep === index ? '#FFFDFC' : '#FFFDFC',
              margin: '0 2px',
              pointerEvents: 'none', // Disabilita il clic sui dot
            }}
          />
        ))}
      </div>
      {currentStep < steps.length - 1 ? (
        <button className='no-style' disabled={disableAll || (steps && steps[currentStep] && steps[currentStep]?.disableNext)} onClick={() => setCurrentStep(currentStep + 1)}><u>Avanti</u></button>
      ) : <button className='no-style' disabled={disableAll} onClick={() => setIsOpen(false)}><u>Chiudi</u></button>}
    </div>
  );
};

export const Close = ({ styles, onClick, disabled }) => {
  return (
    <div className='d-flex justify-content-end'>
      {console.log(disabled) }
      <img src={close_img} onClick={onClick} alt='' className='pointer' style={{maxWidth:'20px'}} />
    </div>
  )
}